import { Edit, SimpleForm, useNotify } from "react-admin";
import CyclicScheduleForm from "./CyclicScheduleForm";
import BackButtonToolbar from "features/BackButtonToolbar";
import { checkProps } from "utils/validations";

const EditCyclicSchedule = () => {
  const notify = useNotify();
  return (
    <Edit
      title="Редакция на поток"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
      onError={error => {
        checkProps(error, notify);
      }}
    >
      <SimpleForm>
        <CyclicScheduleForm mode={"edit"} />
      </SimpleForm>
    </Edit>
  );
};
export default EditCyclicSchedule;
